(() => {
  const init = () => {
    const bar = document.querySelector('[data-medpins-variant-quick-buy]');
    if (!bar || bar.dataset.ready === 'true') return;
    bar.dataset.ready = 'true';

    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const add = bar.querySelector('[data-quick-buy-add]');
    const label = bar.querySelector('[data-quick-buy-label]');
    const price = bar.querySelector('[data-quick-buy-price]');
    const variantName = bar.querySelector('[data-quick-buy-variant]');
    const addText = bar.dataset.addText || 'Añadir al carrito';
    const soldText = bar.dataset.soldText || 'Agotado';
    const currency = bar.dataset.currency || 'EUR';

    const getPrimaryButton = () =>
      document.querySelector('product-info product-form button[name="add"]') ||
      document.querySelector('product-info product-form button[type="submit"]');

    const update = (variant) => {
      if (!variant) return;

      price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'es', {
        style: 'currency',
        currency
      }).format(Number(variant.price) / 100);

      if (variantName) {
        variantName.textContent = variant.title || '';
      }

      add.disabled = !variant.available;
      label.textContent = variant.available ? addText : soldText;
      bar.classList.add('is-visible');
    };

    add.addEventListener('click', () => {
      const primary = getPrimaryButton();
      if (primary && !primary.disabled) primary.click();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event?.data?.variant;
        if (!variant) return;

        // Dawn has already switched to the selected variant image and,
        // when needed, scrolled the image back into view.
        window.requestAnimationFrame(() => {
          window.setTimeout(() => update(variant), 80);
        });
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();